import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Link } from 'react-router-dom';

import SpinnerLoader from 'rebook/apps/base/components/SpinnerLoader';

import styles from './style.scss';

// THEMES: primary, secondary, advert
const Button = (props) => {
  const {
    children, elementType, extraClassName, handleClick,
    isDisabled, isInProgress, theme, type, size, url, link,
    handleMouseOver, handleMouseLeave, buttonRef,
  } = props;

  const buttonProps = {
    children,
    className: classNames(
      styles[`${theme}Button`],
      size && `${size}Size`,
      (isDisabled || isInProgress) && 'isDisabled',
      extraClassName,
    ),
    onClick: handleClick,
    onMouseOver: handleMouseOver,
    onMouseLeave: handleMouseLeave,
  };

  const content = isInProgress
    ? (
      <span ref={buttonRef} className={styles.spinner}>
        <SpinnerLoader theme="passive" size={size} />
      </span>
    )
    : <span ref={buttonRef}>{children}</span>;

  if (elementType === 'span') {
    return <span {...buttonProps} ref={buttonRef}>{content}</span>;
  }
  else if (link) {
    return <Link to={link} {...buttonProps} ref={buttonRef}>{content}</Link>;
  }
  else if (url) {
    return <a href={url} ref={buttonRef} {...buttonProps}>{content}</a>;
  }

  return <button type={type} disabled={isDisabled || isInProgress} {...buttonProps}>{content}</button>;
};

Button.propTypes = {
  type: PropTypes.string,
  isDisabled: PropTypes.bool,
  onClick: PropTypes.func,
  extraClassName: PropTypes.string,
  isInProgress: PropTypes.bool,
  size: PropTypes.string,
  url: PropTypes.string,
  theme: PropTypes.string,
};

Button.defaultProps = {
  theme: 'primary',
};

export default Button;
